window.FileControlsBehaviour = (function () {
    function parse(element: any) {
        installCustomFileInputs(element);
    }

    function unbindWindowWarning() {
        window.onbeforeunload = null;
    }
    function deleteFile(removeButton, parentSelector, fileSelector) {
        const parent = $(removeButton).parent(parentSelector);
        const file = $(fileSelector, parent);

        if (file.val() != '') {
            const isConfirmed = confirm(
                Localization.getString(
                    'FileControls.DeleteFile',
                    'Удалить файл?'
                )
            );
            if (isConfirmed) {
                file.val('');
                $(removeButton)
                    .siblings('label')
                    .children('mark')
                    .text(
                        Localization.getString(
                            'FileControls.NoFiles',
                            'Файл не выбран'
                        )
                    );
                $(removeButton).css('display', 'none');
            }
        }

        const fileNames = [];
        const totalFiles = $(parentSelector).find('[type="file"]');

        $.each(totalFiles, function (i, item) {
            const value = $(totalFiles[i]).val();
            if (value != '') {
                fileNames.push(value);
            }
        });

        if (fileNames.length == 0) window.onbeforeunload = null;
    }

    function installCustomFileInputs(element) {
        const customFiles = $('[custom-file]', element).not(
            '[custom-file-installed]'
        );

        for (let i = 0; i < customFiles.length; i++) {
            const customFileElement = $(customFiles[i]);
            customFileElement.attr('custom-file-installed', 'true');
            customFileElement.change(function () {
                let isError = false;
                let errorMessage = '';

                const maxUSerSize = parseInt(
                    $(this).attr('custom-file-max-size')
                ); //мегабайты
                const maxSizeBytes: number = maxUSerSize * 1024 * 1024; //байты
                const uploadButton = $('[custom-file-uploadButton]');
                if (this.files.length == 0) {
                    RollbackFileControls(this, uploadButton);
                    return;
                }
                const fileSize: number = this.files[0].size;

                if (fileSize > maxSizeBytes) {
                    errorMessage =
                        Localization.getString(
                            'FileControls.MaxUserSize1',
                            'Размер файла не должен превышать '
                        ) +
                        maxUSerSize +
                        Localization.getString(
                            'FileControls.MaxUserSize2',
                            ' Мб'
                        );
                    isError = true;
                }

                const allowedExtensions = $(this)
                    .attr('custom-file-extensions')
                    .split(',');
                const fileName: string = $(this).val();
                const extension: string = fileName.replace(/^.*\./, '');

                if ($.inArray(extension, allowedExtensions) == -1) {
                    errorMessage =
                        Localization.getString(
                            'FileControls.AllowedExtensions1',
                            'Допускаются только '
                        ) +
                        allowedExtensions.toString() +
                        Localization.getString(
                            'FileControls.AllowedExtensions2',
                            ' расширения файлов'
                        );
                    isError = true;
                }

                if (isError) {
                    alert(errorMessage);
                    RollbackFileControls(this, uploadButton);
                } else {
                    if (uploadButton.length > 0) {
                        uploadButton.removeClass('m-disabled');
                    }
                    const uploadPathElement = $(
                        '[custom-file-uploadPath-element]'
                    );
                    if (uploadPathElement.length > 0) {
                        uploadPathElement.html(
                            fileName.split(/(\\|\/)/g).pop()
                        );
                    }

                    if (
                        $(this).attr('custom-file-warning') == 'true' &&
                        this.files[0] != null
                    ) {
                        window.onbeforeunload = function () {
                            return Localization.getString(
                                'FileControls.FilesWillBeDeleted',
                                'При перезагрузке страницы прикрепленные файлы будут удалены'
                            );
                        };
                    }
                }
            });
        }
    }

    function RollbackFileControls(inputElement: any, uploadButton: JQuery) {
        const inputWrapper = $(inputElement);
        inputWrapper.val('');
        if (inputElement.files.length > 0) inputElement.files[0] = null;
        if (uploadButton.length > 0) {
            uploadButton.addClass('m-disabled');
        }
        $('[custom-file-uploadPath-element]').text(
            window.Localization.getString(
                'Scripts_Shared_Infrastructure.CustomFileBehaviour_3',
                'Загрузить файл'
            )
        );
    }

    return {
        parse,
        unbindWindowWarning,
        deleteFile,
    };
})();
